module.exports = __webpack_public_path__ + "assets/img/rechirp-on.1187fa33.svg";